export enum DatumTypEnum {
  ERFASSUNGSDATUM = 'ERFASSUNGSDATUM',
  VERSANDDATUM = 'VERSANDDATUM',
  ZUSTELLDATUM = 'ZUSTELLDATUM',
}
